export const termsOfService = `# DORIDIUM TERMS OF SERVICE

*Last updated: Aug 31st 2025*

Welcome to Doridium (“we,” “us,” or “our”). We are based in Seattle, Washington, USA. We sell and ship original fine art directly to customers. By using our website and placing an order, you agree to the following Terms of Service. Please read them carefully.

# 1. Overview

By using this website or placing an order, you represent that you are at least 18 years of age or have consent from a legal guardian. These Terms govern your use of our website and your purchase of any products.

# 2. Orders and Payments

All prices are listed in U.S. Dollars and are subject to change without notice.

Full payment is required at the time of order.

We reserve the right to cancel any order at our discretion, including due to pricing errors or inventory issues.

# 3. Shipping and Delivery

We ship from Seattle, Washington, USA.

We are not responsible for delays due to third-party shipping providers.

You are responsible for providing an accurate and complete shipping address.

Risk of loss transfers to you once the order is handed off to the shipping carrier.

# 4. Returns and Refunds

Please refer to our [Refund Policy](refund-policy)

In general, due to the nature of original fine art, all sales are final.

We may, at our sole discretion, offer a refund, replacement, or store credit.

This policy does not limit any statutory rights you may have under applicable consumer laws.

# 5. Privacy and Data Use

We collect your name, email address, and shipping address to fulfill and communicate about your order.

We do not sell or share your data beyond what is necessary to process and deliver your purchase.

For more details, please refer to our [Privacy Policy](privacy-policy).

# 6. Intellectual Property

All website content and original artworks are the exclusive property of Doridium and may not be used, reproduced, or distributed without written permission.

# 7. Limitation of Liability

To the extent permitted by law, our liability is limited to the amount you paid for the product. We are not responsible for indirect, incidental, or consequential damages arising from use of this website or our products.

# 8. Governing Law and Jurisdiction

These Terms shall be governed by the laws of the State of Washington, without regard to conflict of laws principles. Any disputes shall be resolved exclusively in the courts located in King County, Washington, USA, and you consent to their jurisdiction.

# 9. International Orders

We currently ship only to select countries. If you are ordering from outside the U.S., you are responsible for any customs duties or local taxes.

Nothing in this agreement affects any non-waivable rights you may have under local consumer protection laws.

# 10. Changes to These Terms

We may update these Terms at any time. Updates will be posted on this page with a new "Last updated" date. Continued use of the website means you accept the revised Terms.

# 11. Language

These Terms are provided in English. Any translations are for convenience only. In the event of a discrepancy between a translated version and the English version, the English version will govern.

Contact:

Doridium  
2226 Eastlake Ave E Unit #789  
Seattle, WA 98102

[contact@doridium.com](mailto:contact@doridium.com)  
`